import React from 'react';
import UserGuides from '../components/UserGuides';

const Guides = () => {
    return (
        <div className="min-h-screen bg-gray-50 pt-20">
            <UserGuides />
        </div>
    );
};

export default Guides;
